<h2 class="multi-unit-selection__headline">{{ 'pages.transport.upload-dialog.multi-unit-shipment' | translate }}</h2>

<div class="mt-2">
  <p-floatlabel variant="on">
    <p-multiSelect
      [options]="handlingUnits()"
      [(ngModel)]="selectedHandlingUnits"
      optionLabel="trackingNumber"
      class="w-100"
    ></p-multiSelect>

    <label for="shippingUnit" class="form-label">
      {{ 'pages.transport.upload-dialog.select-handling-unit' | translate }}
    </label>
  </p-floatlabel>
</div>
